import { IconType } from "react-icons";
import { TbAlertTriangle, TbCalendar } from "react-icons/tb";

export type NotificationVariant = "appointment" | "incident";

export const NOTIFICATION_VARIANT_CONFIG: Record<
    NotificationVariant,
    {
        icon: IconType;
        labelKey: string;
        accent: string;
        iconBg: string;
        iconColor: string;
        glow: string;
    }
> = {
    appointment: {
        icon: TbCalendar,
        labelKey: "appointment_label",
        accent: "border-l-amber-400 dark:border-l-amber-500",
        iconBg: "bg-amber-500/15",
        iconColor: "text-amber-600 dark:text-amber-500",
        glow: "shadow-amber-500/10",
    },
    incident: {
        icon: TbAlertTriangle,
        labelKey: "incidents",
        accent: "border-l-orange-500 dark:border-l-orange-400",
        iconBg: "bg-orange-500/15",
        iconColor: "text-orange-600 dark:text-orange-500",
        glow: "shadow-orange-500/10",
    },
};
